import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vShow as _vShow, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withModifiers as _withModifiers, Teleport as _Teleport, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "documents-panel" }
const _hoisted_2 = { class: "filter-toggle-bar" }
const _hoisted_3 = {
  key: 0,
  class: "filter-active-badge"
}
const _hoisted_4 = { class: "filter-bar" }
const _hoisted_5 = { class: "filter-group" }
const _hoisted_6 = ["value"]
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "filter-group" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "filter-group" }
const _hoisted_11 = ["value"]
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "filter-group" }
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "filter-group" }
const _hoisted_16 = ["value"]
const _hoisted_17 = {
  key: 0,
  class: "selection-bar"
}
const _hoisted_18 = { class: "sel-count" }
const _hoisted_19 = { class: "sel-actions" }
const _hoisted_20 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_21 = {
  key: 2,
  class: "doc-list"
}
const _hoisted_22 = { class: "col-check" }
const _hoisted_23 = ["checked", "onChange"]
const _hoisted_24 = { class: "col-title" }
const _hoisted_25 = ["data-type"]
const _hoisted_26 = { class: "doc-title-wrap" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "doc-date-mobile" }
const _hoisted_29 = {
  key: 0,
  class: "doc-preview"
}
const _hoisted_30 = { class: "col-project" }
const _hoisted_31 = { class: "col-date" }
const _hoisted_32 = { class: "col-author" }
const _hoisted_33 = ["title"]
const _hoisted_34 = { class: "author-name" }
const _hoisted_35 = { class: "col-actions" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "lang-modal" }
const _hoisted_39 = { class: "lang-modal-header" }
const _hoisted_40 = { class: "lang-modal-title" }
const _hoisted_41 = { class: "lang-grid" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = { class: "lang-flag" }
const _hoisted_44 = { class: "lang-label" }
const _hoisted_45 = { class: "lang-modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SkeletonList = _resolveComponent("SkeletonList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "filter-toggle-btn",
        type: "button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showFilters = !_ctx.showFilters))
      }, [
        _cache[13] || (_cache[13] = _createElementVNode("svg", {
          width: "14",
          height: "14",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, [
          _createElementVNode("polygon", { points: "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" })
        ], -1)),
        _cache[14] || (_cache[14] = _createTextVNode(" Filtros ", -1)),
        (_ctx.activeFilterCount > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.activeFilterCount), 1))
          : _createCommentVNode("", true),
        (_openBlock(), _createElementBlock("svg", {
          class: _normalizeClass(["filter-chevron", { open: _ctx.showFilters }]),
          width: "12",
          height: "12",
          viewBox: "0 0 12 12",
          fill: "none"
        }, [...(_cache[12] || (_cache[12] = [
          _createElementVNode("path", {
            d: "M2 4l4 4 4-4",
            stroke: "currentColor",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, -1)
        ]))], 2))
      ]),
      (_ctx.activeFilterCount > 0)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "filter-clear-btn",
            type: "button",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clearFilters && _ctx.clearFilters(...args)))
          }, "Limpar filtros"))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_Transition, { name: "filter-bar" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[16] || (_cache[16] = _createElementVNode("label", {
              class: "filter-label",
              for: "docTypeFilter"
            }, "Tipo", -1)),
            _createElementVNode("select", {
              id: "docTypeFilter",
              class: "filter-select",
              value: _ctx.docFilterType,
              onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('set-doc-type', ($event.target as HTMLSelectElement).value)))
            }, [
              _cache[15] || (_cache[15] = _createElementVNode("option", { value: "" }, "Todos os tipos", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allTypes, (item) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: item,
                  value: item
                }, _toDisplayString(item), 9, _hoisted_7))
              }), 128))
            ], 40, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[18] || (_cache[18] = _createElementVNode("label", {
              class: "filter-label",
              for: "docProjectFilter"
            }, "Projeto", -1)),
            _withDirectives(_createElementVNode("select", {
              id: "docProjectFilter",
              class: "filter-select",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.projectFilter) = $event))
            }, [
              _cache[17] || (_cache[17] = _createElementVNode("option", { value: "" }, "Todos os projetos", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projectOptions, (proj) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: proj,
                  value: proj
                }, _toDisplayString(proj), 9, _hoisted_9))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.projectFilter]
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _cache[20] || (_cache[20] = _createElementVNode("label", {
              class: "filter-label",
              for: "docUserFilter"
            }, "Autor", -1)),
            _createElementVNode("select", {
              id: "docUserFilter",
              class: "filter-select",
              value: _ctx.docUserFilter,
              onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('set-doc-user', ($event.target as HTMLSelectElement).value)))
            }, [
              _cache[19] || (_cache[19] = _createElementVNode("option", { value: "" }, "Todos os autores", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.docUserOptions, (item) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: item,
                  value: item
                }, _toDisplayString(item), 9, _hoisted_12))
              }), 128))
            ], 40, _hoisted_11)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _cache[21] || (_cache[21] = _createElementVNode("label", {
              class: "filter-label",
              for: "docDateFrom"
            }, "De", -1)),
            _createElementVNode("input", {
              id: "docDateFrom",
              class: "filter-input",
              value: _ctx.docDateFrom,
              type: "date",
              onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('set-doc-date-from', ($event.target as HTMLInputElement).value)))
            }, null, 40, _hoisted_14)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _cache[22] || (_cache[22] = _createElementVNode("label", {
              class: "filter-label",
              for: "docDateTo"
            }, "Até", -1)),
            _createElementVNode("input", {
              id: "docDateTo",
              class: "filter-input",
              value: _ctx.docDateTo,
              type: "date",
              onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('set-doc-date-to', ($event.target as HTMLInputElement).value)))
            }, null, 40, _hoisted_16)
          ])
        ], 512), [
          [_vShow, _ctx.showFilters]
        ])
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "sel-bar" }, {
      default: _withCtx(() => [
        (_ctx.selectedDocs.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.selectedDocs.length) + " selecionado" + _toDisplayString(_ctx.selectedDocs.length > 1 ? 's' : ''), 1),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("button", {
                  class: "export-btn export-btn--doc",
                  type: "button",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.openLang('doc')))
                }, [...(_cache[23] || (_cache[23] = [
                  _createElementVNode("svg", {
                    width: "14",
                    height: "14",
                    viewBox: "0 0 15 15",
                    fill: "none"
                  }, [
                    _createElementVNode("rect", {
                      x: "2",
                      y: "1",
                      width: "11",
                      height: "13",
                      rx: "1.5",
                      stroke: "currentColor",
                      "stroke-width": "1.3"
                    }),
                    _createElementVNode("path", {
                      d: "M5 5h5M5 7.5h5M5 10h3",
                      stroke: "currentColor",
                      "stroke-width": "1.3",
                      "stroke-linecap": "round"
                    })
                  ], -1),
                  _createTextVNode(" Word ", -1)
                ]))]),
                _createElementVNode("button", {
                  class: "export-btn export-btn--pdf",
                  type: "button",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.openLang('pdf')))
                }, [...(_cache[24] || (_cache[24] = [
                  _createElementVNode("svg", {
                    width: "14",
                    height: "14",
                    viewBox: "0 0 15 15",
                    fill: "none"
                  }, [
                    _createElementVNode("path", {
                      d: "M3 1.5h6l3 3V13a.5.5 0 01-.5.5H3A.5.5 0 012.5 13V2A.5.5 0 013 1.5z",
                      stroke: "currentColor",
                      "stroke-width": "1.3"
                    }),
                    _createElementVNode("path", {
                      d: "M9 1.5V4.5h3M5 7h1.5c.828 0 1.5.448 1.5 1s-.672 1-1.5 1H5V10",
                      stroke: "currentColor",
                      "stroke-width": "1.2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    })
                  ], -1),
                  _createTextVNode(" PDF ", -1)
                ]))]),
                _createElementVNode("button", {
                  class: "export-btn export-btn--delete",
                  type: "button",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('delete-docs')))
                }, [...(_cache[25] || (_cache[25] = [
                  _createElementVNode("svg", {
                    width: "13",
                    height: "13",
                    viewBox: "0 0 14 14",
                    fill: "none"
                  }, [
                    _createElementVNode("path", {
                      d: "M2 3.5h10M5.5 3.5V2.5h3V3.5M4.5 3.5v7.5h5V3.5",
                      stroke: "currentColor",
                      "stroke-width": "1.3",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    })
                  ], -1),
                  _createTextVNode(" Apagar ", -1)
                ]))])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.showSkeleton)
      ? (_openBlock(), _createBlock(_component_SkeletonList, {
          key: 0,
          variant: "row",
          count: 5,
          columns: [3, 40, 15, 10, 15]
        }))
      : (_ctx.displayedItems.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [...(_cache[26] || (_cache[26] = [
            _createStaticVNode("<svg width=\"44\" height=\"44\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.3\" data-v-a0edfff4><path d=\"M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z\" data-v-a0edfff4></path><polyline points=\"14 2 14 8 20 8\" data-v-a0edfff4></polyline><line x1=\"16\" y1=\"13\" x2=\"8\" y2=\"13\" data-v-a0edfff4></line><line x1=\"16\" y1=\"17\" x2=\"8\" y2=\"17\" data-v-a0edfff4></line><polyline points=\"10 9 9 9 8 9\" data-v-a0edfff4></polyline></svg><p class=\"empty-title\" data-v-a0edfff4>Nenhum documento encontrado</p><p class=\"empty-sub\" data-v-a0edfff4>Tente ajustar os filtros acima.</p>", 3)
          ]))]))
        : (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _cache[29] || (_cache[29] = _createStaticVNode("<div class=\"doc-list-header\" data-v-a0edfff4><div class=\"col-check\" data-v-a0edfff4></div><div class=\"col-title\" data-v-a0edfff4>Documento</div><div class=\"col-project\" data-v-a0edfff4>Projeto</div><div class=\"col-date\" data-v-a0edfff4>Data</div><div class=\"col-author\" data-v-a0edfff4>Autor</div><div class=\"col-actions\" data-v-a0edfff4></div></div>", 1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedItems, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.id,
                class: _normalizeClass(["doc-row", { selected: _ctx.selectedDocs.includes(item.id) }])
              }, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("input", {
                    class: "doc-checkbox",
                    type: "checkbox",
                    checked: _ctx.selectedDocs.includes(item.id),
                    onChange: ($event: any) => (_ctx.$emit('toggle-doc', item.id))
                  }, null, 40, _hoisted_23)
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("span", {
                    class: "type-badge",
                    "data-type": item.type
                  }, _toDisplayString(item.type || 'Doc'), 9, _hoisted_25),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("button", {
                      class: "doc-title doc-title-link",
                      type: "button",
                      onClick: ($event: any) => (_ctx.$emit('view', item.id))
                    }, _toDisplayString(item.title), 9, _hoisted_27),
                    _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.formatReportDate(item.reportDate)), 1),
                    (_ctx.activitiesText(item))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.activitiesText(item)), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, _toDisplayString(item.attraction), 1),
                _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.formatReportDate(item.reportDate)), 1),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", {
                    class: "author-avatar",
                    title: item.author.name
                  }, _toDisplayString(item.author.name?.charAt(0)?.toUpperCase()), 9, _hoisted_33),
                  _createElementVNode("span", _hoisted_34, _toDisplayString(item.author.name), 1)
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("button", {
                    class: "row-link",
                    type: "button",
                    onClick: ($event: any) => (_ctx.$emit('view', item.id))
                  }, [...(_cache[27] || (_cache[27] = [
                    _createElementVNode("svg", {
                      width: "13",
                      height: "13",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2"
                    }, [
                      _createElementVNode("circle", {
                        cx: "11",
                        cy: "11",
                        r: "8"
                      }),
                      _createElementVNode("path", { d: "m21 21-4.35-4.35" })
                    ], -1),
                    _createTextVNode(" Ver ", -1)
                  ]))], 8, _hoisted_36),
                  _createElementVNode("button", {
                    class: "row-link",
                    type: "button",
                    onClick: ($event: any) => (_ctx.$emit('edit', item.id))
                  }, [...(_cache[28] || (_cache[28] = [
                    _createElementVNode("svg", {
                      width: "13",
                      height: "13",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2"
                    }, [
                      _createElementVNode("path", { d: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" }),
                      _createElementVNode("path", { d: "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" })
                    ], -1),
                    _createTextVNode(" Editar ", -1)
                  ]))], 8, _hoisted_37)
                ])
              ], 2))
            }), 128))
          ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.showLangModal)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "lang-overlay",
            onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.showLangModal = false), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("h3", _hoisted_40, _toDisplayString(_ctx.exportTarget === 'doc' ? 'Gerar documento Word (.docx)' : 'Gerar PDF'), 1),
                _cache[30] || (_cache[30] = _createElementVNode("p", { class: "lang-modal-sub" }, "Selecione o idioma do documento gerado", -1))
              ]),
              _createElementVNode("div", _hoisted_41, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.LANGUAGES, (loc) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: loc.code,
                    class: "lang-option",
                    type: "button",
                    onClick: ($event: any) => (_ctx.selectLang(loc.code))
                  }, [
                    _createElementVNode("span", _hoisted_43, _toDisplayString(loc.flag), 1),
                    _createElementVNode("span", _hoisted_44, _toDisplayString(loc.label), 1)
                  ], 8, _hoisted_42))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("button", {
                  class: "lang-cancel",
                  type: "button",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showLangModal = false))
                }, "Cancelar")
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]))
  ]))
}